import type { ZxcvbnResult } from "@zxcvbn-ts/core";

/**
 * パスワードの強度を 0〜4 のスコアで返す関数
 * - userInputs に含まれる語（メールアドレスやサービス名など）を使ったパスワードは低く評価される
 */
export type PasswordStrengthEstimator = (password: string, userInputs: string[]) => ZxcvbnResult["score"];

let estimatorPromise: Promise<PasswordStrengthEstimator> | undefined;

/**
 * パスワードの強度判定関数を読み込む
 * - 辞書が大きい（gzip で約 230KB）ため、初期バンドルに乗せず、使う画面で動的に読み込む
 * - 2 回目以降は読み込み済みの関数を返す。読み込みに失敗したときは次の呼び出しで読み込み直す
 */
export const loadPasswordStrengthEstimator = (): Promise<PasswordStrengthEstimator> => {
	estimatorPromise ??= Promise.all([import("@zxcvbn-ts/core"), import("@zxcvbn-ts/language-common")])
		.then(([core, common]) => {
			core.zxcvbnOptions.setOptions({
				graphs: common.adjacencyGraphs,
				dictionary: { ...common.dictionary },
			});

			return (password: string, userInputs: string[]) => core.zxcvbn(password, userInputs).score;
		})
		.catch((error: unknown) => {
			estimatorPromise = undefined;
			throw error;
		});

	return estimatorPromise;
};
